import { showBackdrop, hideBackdrop } from '../components/backdrop';
import { atQuery } from '../components/mediaQueries';

$(function () {
  const $countrySwitcher = $('.country-switcher');
  const $countrySwitcherModal = $('.country-switcher__modal');

  if (!$countrySwitcher.length || !$countrySwitcherModal.length) return;

  const $countrySwitcherModalClose = $('.country-switcher__modal__close');

  $countrySwitcher.on('click', function () {
    $countrySwitcherModal.addClass('open');
    $('body').addClass('country-lang-open');

    atQuery('min', 'md', () => {
      showBackdrop();
    });
  });

  const $activeCountry = $countrySwitcher.find('.country-switcher__active-country');
  if ($activeCountry.length <= 0) return;

  $activeCountry.on('blur', function (e) {
    if (!e.relatedTarget || !e.relatedTarget.closest('.country-switcher__dropdown')) {
      $countrySwitcher.removeClass('open');
    }
  });

  $($countrySwitcherModalClose).on('click', function(e) {
    e.stopPropagation();
    $countrySwitcherModal.removeClass('open');
    $('body').removeClass('country-lang-open');

    atQuery('min', 'md', () => {
      hideBackdrop();
    });
  });
});
